import { combineReducers } from "@reduxjs/toolkit";
import sessionSlice from "./sessionSlice";
import refreshTokenSlice from "./refreshTokenSlice";

export const sessionReducer = combineReducers({
  session: sessionSlice,
  refreshToken: refreshTokenSlice
});